module.exports = __webpack_public_path__ + "static/media/Movingful-MWDG-Final-White.63649c22.svg";